import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";

interface selectPair {
    selectedPair: string,
    pairName:string,
    pairOneSymbol:string,
    pairTwoSymbol:string,
    symbolOneId:string,
    symbolTwoId:string 
   
  }

const initialState :selectPair= {
    selectedPair: 'Select',
    pairName:'',
    pairOneSymbol:'',
    pairTwoSymbol:'',
    symbolOneId:'',
    symbolTwoId:'' 
};

export const selectedPairSlice = createSlice({
    name: "selectedPair",
    initialState,
    reducers: {
        updatePair: (state, action: PayloadAction<{
            selectedPair:string,
            pairName:string,
            pairOneSymbol:string,
            pairTwoSymbol:string,
            symbolOneId:string,
            symbolTwoId:string  
        }>) => {

            state.selectedPair = action.payload.selectedPair
            state.pairName = action.payload.pairName
            state.pairOneSymbol = action.payload.pairOneSymbol
            state.pairTwoSymbol = action.payload.pairTwoSymbol
            state.symbolOneId = action.payload.symbolOneId
            state.symbolTwoId = action.payload.symbolTwoId
        },
    },
});
export const { updatePair } = selectedPairSlice.actions;

export default selectedPairSlice.reducer;
